/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  useState,
  useEffect,
} from 'react'

import { Helmet } from "react-helmet";
import { useSelector, shallowEqual, useDispatch } from 'react-redux';

import { useNavigate } from 'react-router-dom';

import LoadingContent from 'app/modules/loading/LoadingContent';
import PurchaseMenu from 'app/utils/PurchaseMenu';
import CheckInDayUseModal from './CheckInDayUseModal';

import {
  fetchDayUses,
} from 'app/services/dayUses';

import {
  formatLongDate,
} from 'app/services/dates';
import { toAbsoluteUrl } from '_metronic/helpers';

const DayUseList = () => {
  const { dayUses, auth } = useSelector((state : any) => ({
    dayUses: state.dayUses,
    auth: state.auth,
  }), shallowEqual);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [list, setList] = useState<any>([]);
  const [openCheckInModal, setOpenCheckInModal] = useState<boolean>(false);

  useEffect(() => {
    dispatch<any>(fetchDayUses()).then((value: any) => {
      setList(value)
    });
  }, [dispatch]);

  useEffect(() => {
    if(!auth.user) {
      navigate('/')
    }
  }, [auth, navigate]);

  const showItem = (item: any) => {
    return <div className="col-lg-6 mb-1 mb-lg-0">
      <div className="d-flex justify-content-center">
        <div
          className="card card-dashed flex-row flex-stack p-4 mb-6 w-100 cursor-pointer"
          onClick={() => navigate(`/compras/day-use/${item.id}`)}
        >
          <div className="d-flex align-items-center me-2">
            <div className="flex-grow-1">
              <div className="d-flex align-items-center fs-2 fw-bold flex-wrap pb-2">{item?.relationships?.plan?.attributes?.name} {item?.attributes?.guest === true && <span className="fs-7 text-note pb-1 mx-2 badge bg-primary">Acompanhante</span>}</div>
              <div className="fs-7 fw-semibold text-gray-700 pb-1">{item?.relationships?.plan?.relationships?.branches?.[0].attributes?.name}</div>
              <div className="fs-7 fw-semibold text-gray-700 pb-1">
                {formatLongDate(item?.attributes?.day)}
              </div>
            </div>
          </div>
          <div className="d-flex ms-5">
            <div className="flex-grow-1 text-uppercase">
              {(item?.relationships?.status?.attributes?.name === 'pending') && <span className="flex d-flex text-warning fs-6 fw-bold">
                Pendente
              </span>}

              {(item?.relationships?.status?.attributes?.name === 'active') && <span className="flex d-flex text-primary fs-6 fw-bold text-center">
                Realizado
              </span>}

              {(item?.relationships?.status?.attributes?.name === 'canceled') && <span className="flex d-flex text-gray-700 fs-6 fw-bold text-center">
                Cancelado
              </span>}
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  const handleOpenCheckInModal = () => {
    setOpenCheckInModal(true);
  };

  const handleCloseCheckInModal = () => {
    setOpenCheckInModal(false);
  };

  return (<>
    <Helmet>
      <title>Minhas compras - Day use - Atacante App</title>
    </Helmet>

    <PurchaseMenu />

    {<div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-0 mb-13'>
        {/* Action Box para Check-in */}
        <div className="mb-10">
          <div
            className="card bg-light-primary border-primary border border-dashed cursor-pointer"
            onClick={() => handleOpenCheckInModal()}
          >
            <div className="card-body d-flex align-items-center p-6">
              <div className="d-flex align-items-center me-5">
                <div className="symbol symbol-40px symbol-circle me-5">
                  <span className="symbol-label bg-primary">
                    <img
                      src={toAbsoluteUrl('/media/custom/tickets.png')}
                      width="25"
                      height="25"
                      className="mx-5 align-self-center text-white"
                      alt="tickets"
                    />
                  </span>
                </div>
                <div className="flex-grow-1">
                  <h3 className="text-primary mb-1">Fazer Check-in</h3>
                  <div className="fw-semibold text-primary">
                    Clique aqui para realizar check-in com seus créditos
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg-icon-primary">
                  <path d="M12.6343 12.5657L8.45001 16.75C8.0358 17.1642 8.0358 17.8358 8.45001 18.25C8.86423 18.6642 9.5358 18.6642 9.95001 18.25L15.4929 12.7071C15.8834 12.3166 15.8834 11.6834 15.4929 11.2929L9.95001 5.75C9.5358 5.33579 8.86423 5.33579 8.45001 5.75C8.0358 6.16421 8.0358 6.83579 8.45001 7.25L12.6343 11.4343C12.9467 11.7467 12.9467 12.2533 12.6343 12.5657Z" fill="currentColor"/>
                </svg>
              </div>
            </div>
          </div>
        </div>

        {list.length > 0 && <>
          <div className="mb-10">
            <h1 className="mb-3">
              Histórico de day use
            </h1>
          </div>
          <div className="row mt-10">
            {list.map(item => {
              return showItem(item)
            })}
          </div>
        </>}

        {dayUses.listLoading === false && list.length === 0 && <div className="my-10 text-center">
          <h2 className="mb-3">
            Você não efetuou nenhuma compra
          </h2>
          <div className="text-muted fw-semibold fs-5">
            Garanta descontos exclusivos para jogar com seus amigos!
          </div>
        </div>}

        {dayUses.listLoading === true && list.length === 0 && <LoadingContent />}
      </div>
    </div>}

    <CheckInDayUseModal
      isOpen={openCheckInModal}
      onClosed={handleCloseCheckInModal}
    />
  </>)
}

export {
  DayUseList
}
